module.exports = __webpack_public_path__ + "media/images/facebook-brands-0e10e76586d2085ac5eb88a0956a2eb2.svg";